export enum DockSection {
    HOME,
    TRANSACTIONS,
    SETTINGS,
}
